// Define and use an InjectionToken object for choosing a provider token for non-class dependencies.
import { InjectionToken } from '@angular/core';

export const SHOULD_SESSION_STORAGE_ENCRYPT = new InjectionToken<boolean>('Encrypt the session storage or not');
